export default "__VITE_ASSET__9bf0968b__"